import React from 'react';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { ChevronDown } from 'lucide-react';
import '../styles/searchableSelect.css';

const filter = createFilterOptions();

const SearchableSelect = ({
  options = [],
  value,
  onChange,
  placeholder = 'Search or select...',
  getOptionLabel = (option) =>
    typeof option === 'string' ? option : option?.label ?? option?.name ?? '',
  isOptionEqualToValue = (option, value) =>
    (option?.id ?? option) === (value?.id ?? value),
  getOptionKey,
  groupBy,
  disabled = false,
  className = '',
  noOptionsText = 'No options available',
}) => {
  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={(event, newValue) => onChange(newValue)}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      getOptionKey={getOptionKey}
      groupBy={groupBy}
      disabled={disabled}
      noOptionsText={noOptionsText}
      popupIcon={<ChevronDown size={20} />}
      className={`searchable-select ${className}`}
      filterOptions={(opts, { inputValue }) => {
        const search = inputValue.trim().toLowerCase();
        return opts.filter(
          (opt) => getOptionLabel(opt)?.toLowerCase().includes(search)
        );
      }}

      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={placeholder}
          variant="outlined"
          className="searchable-select-input"
        />
      )}
      slotProps={{
        paper: { className: 'searchable-select-dropdown' },
      }}
    />

  );
};

export default SearchableSelect;
